import {FC} from "react";
import {Outlet} from "react-router-dom";
import {Navigation} from "components/Navigation/Navigation";
import {Icon} from "assets/Icon";
import {Link} from "react-router-dom";
import {useAdminFullPageLayout} from "./useAdminFullPageLayout";
import "./AdminFullPageLayout.scss";

export const AdminFullPageLayout: FC = () => {
  const {toggleMenu, isSidebar, logout} = useAdminFullPageLayout();

  return (
    <div className="AdminFullPageLayout">
      <div
        className={`AdminFullPageLayout-Sidebar-hamburger${isSidebar ? " active" : ""}`}
        onClick={() => toggleMenu()}
      >
        <Icon name={isSidebar ? "cross" : "menu"} />
      </div>
      <div
        className={`AdminFullPageLayout-Sidebar-shadow${isSidebar ? " active" : ""}`}
        onClick={() => toggleMenu()}
      />
      <div className={`AdminFullPageLayout-Sidebar${isSidebar ? " active" : ""}`}>
        <div>
        <div className="top">
          <div className="AdminFullPageLayout-Logo">
            <Link to="/">
              <Icon name="logo3" className="autoSize" />
            </Link>
          </div>
          <Navigation callback={toggleMenu} />
        </div>
        <div className="AdminFullPageLayout-Logout" onClick={() => logout()}>
          <Icon name="exit" />
          <span>Log Out</span>
        </div>
        </div>
      </div>
      <div className="AdminFullPageLayout-body">
        <Outlet />
      </div>
    </div>
  );
};
